export var MediaPurpose;
(function (MediaPurpose) {
    MediaPurpose[MediaPurpose["Other"] = 1] = "Other";
    MediaPurpose[MediaPurpose["GatePass"] = 2] = "GatePass";
    MediaPurpose[MediaPurpose["TransporterCOI"] = 3] = "TransporterCOI";
    MediaPurpose[MediaPurpose["TransporterW9"] = 4] = "TransporterW9";
    MediaPurpose[MediaPurpose["ProfilePicture"] = 5] = "ProfilePicture";
    MediaPurpose[MediaPurpose["BillOfLading"] = 6] = "BillOfLading";
    MediaPurpose[MediaPurpose["Signature"] = 7] = "Signature";
    MediaPurpose[MediaPurpose["BillOfLadingAdditional"] = 8] = "BillOfLadingAdditional";
    MediaPurpose[MediaPurpose["NissanYardExit"] = 9] = "NissanYardExit";
    MediaPurpose[MediaPurpose["NissanVehicleDelivery"] = 10] = "NissanVehicleDelivery";
    MediaPurpose[MediaPurpose["NissanFreightInvoice"] = 11] = "NissanFreightInvoice";
    MediaPurpose[MediaPurpose["SecurePassQR"] = 12] = "SecurePassQR";
    MediaPurpose[MediaPurpose["SecurePassPDF"] = 13] = "SecurePassPDF";
    MediaPurpose[MediaPurpose["Report"] = 14] = "Report";
    MediaPurpose[MediaPurpose["ReportTemplate"] = 15] = "ReportTemplate";
    MediaPurpose[MediaPurpose["PriceChecker"] = 16] = "PriceChecker";
    MediaPurpose[MediaPurpose["GatePassBulk"] = 17] = "GatePassBulk";
    MediaPurpose[MediaPurpose["SuperDispatchPriceChecker"] = 18] = "SuperDispatchPriceChecker";
    MediaPurpose[MediaPurpose["CampaignImageDesktop"] = 19] = "CampaignImageDesktop";
    MediaPurpose[MediaPurpose["CampaignImageMobile"] = 20] = "CampaignImageMobile";
    MediaPurpose[MediaPurpose["QuickQuoteVehicle"] = 21] = "QuickQuoteVehicle";
})(MediaPurpose || (MediaPurpose = {}));
